type OrderType = { order?: number | null };

export const sortByOrder = (a?: OrderType, b?: OrderType): any => (!a || !b ? 1 : (a.order || 0) - (b.order || 0));
